const HEADER_SELECTOR = '.ag-header-cell, .ag-header-group-cell';

const overlaps = (first, second) =>
    first.bottom > second.top + 1 &&
    first.top < second.bottom - 1 &&
    first.right > second.left + 1 &&
    first.left < second.right - 1;

const headerFromEvent = (mouseEvent) => {
    const target = mouseEvent?.target;
    const element = target?.nodeType === 1 ? target : target?.parentElement;
    return element?.closest?.(HEADER_SELECTOR) ?? null;
};

/** Header tooltips are clamped inside a short grid and cover the column title. */
export function keepTooltipClearOfHeader(params) {
    if (params?.type !== 'tooltip' || !params.ePopup) return;

    const header = headerFromEvent(params.mouseEvent);
    if (!header) return;

    const popup = params.ePopup;
    const headerBox = header.getBoundingClientRect();
    const popupBox = popup.getBoundingClientRect();
    if (!overlaps(popupBox, headerBox)) return;

    const gap = 4;
    const belowTop = headerBox.bottom + gap;
    const aboveTop = headerBox.top - popupBox.height - gap;
    const fitsBelow = belowTop + popupBox.height <= window.innerHeight - gap;
    const nextTop = fitsBelow || aboveTop < gap ? belowTop : aboveTop;
    const currentTop = Number.parseFloat(popup.style.top);
    if (!Number.isFinite(currentTop)) return;

    popup.style.top = `${currentTop + (nextTop - popupBox.top)}px`;
}
